module.exports = __webpack_public_path__ + "static/media/icon3.2a22b825.svg";